import { render } from "./app-header.vue?vue&type=template&id=bba2c89c"
import script from "./app-header.vue?vue&type=script&lang=js"
export * from "./app-header.vue?vue&type=script&lang=js"

import "./app-header.vue?vue&type=style&index=0&id=bba2c89c&lang=less"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__